export const intersection = <T>(...arrays: Array<T[]>): T[] =>
    arrays
        .reduce((acc, array) => acc.filter((value) => array.includes(value)))
        .reduce((acc, value) => (acc.includes(value) ? acc : [...acc, value]), [] as T[]);
